// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMinus as RawLucideMinus } from "lucide-react";
export const LucideMinus = /* @__PURE__ */ createIcon(RawLucideMinus, "LucideMinus", 2);
